import { type FC } from 'react';
import { InputText } from 'primereact/inputtext';
import { ColorPicker } from 'primereact/colorpicker';
import { type paths } from '../endpoint/Schema';

export const CustomColourPicker: FC<{
  colour: paths['/api/v2/admin/tenant/app-color']['get']['responses']['200']['content']['application/json'][0];
  onChange: (type: string, value: string) => void;
  onFocus?: () => void;
  disabled?: boolean;
}> = (props) => {
  const c = props.colour.value?.replace('#', '');

  return (
    <div>
      <div>{props.colour.displayName}</div>
      <div className="p-inputgroup">
        <InputText
          value={c}
          className="p-inputtext-sm"
          onChange={(e) => {
            const newValue = `#${e.target.value}`;
            if (props.colour.type) props.onChange(props.colour.type, newValue);
          }}
          onFocus={() => {
            props.onFocus?.();
          }}
          disabled={props.disabled}
        />
        <ColorPicker
          className="p-inputgroup-addon w-2"
          format="hex"
          value={c}
          disabled={props.disabled}
          onShow={() => {
            props.onFocus?.();
          }}
          onChange={(e) => {
            const newValue = `#${e.value?.toString() ?? ''}`;
            if (props.colour.type) props.onChange(props.colour.type, newValue);
          }}
        />
      </div>
    </div>
  );
};
